import { CalendarRange } from "lucide-react";

export const PERIODOS = [
  { key: "hoje", label: "Hoje" },
  { key: "semana", label: "Esta semana" },
  { key: "mes", label: "Este mês" },
  { key: "personalizado", label: "Personalizado" },
];

const fmtBR = (iso) => (iso ? iso.slice(0, 10).split("-").reverse().join("/") : "");

// Texto do período conforme o retorno do backend (inicio/fim).
export const descreverPeriodo = (periodo, inicio, fim) => {
  if (periodo === "hoje") return `hoje (${fmtBR(inicio)})`;
  if (periodo === "semana") return `esta semana (${fmtBR(inicio)} – ${fmtBR(fim)})`;
  if (periodo === "mes") {
    const [y, m] = (inicio || "").split("-").map(Number);
    return y ? `em ${new Date(y, m - 1, 1).toLocaleDateString("pt-BR", { month: "long", year: "numeric" })}` : "este mês";
  }
  return `de ${fmtBR(inicio)} a ${fmtBR(fim)}`;
};

/**
 * Filtro de período do painel "Meu Desempenho" (jun/2026): Hoje · Esta semana · Este mês · Personalizado.
 * `value` = { periodo, inicio, fim }. Dispara onChange a cada alteração (o painel recarrega sozinho).
 */
export function DesempenhoPeriodFilter({ value, onChange }) {
  const set = (patch) => onChange({ ...value, ...patch });
  const invalido = value.periodo === "personalizado" && value.inicio && value.fim && value.inicio > value.fim;
  return (
    <div className="space-y-2" data-testid="desempenho-period-filter">
      <div className="flex flex-wrap justify-center gap-1 bg-orange-100 rounded-full p-1" role="tablist" aria-label="Período">
        {PERIODOS.map((p) => {
          const active = value.periodo === p.key;
          return (
            <button key={p.key} type="button" role="tab" aria-selected={active} onClick={() => set({ periodo: p.key })}
              className={`px-3 py-1 rounded-full text-xs font-bold transition ${active ? "bg-white text-orange-700 shadow-sm" : "text-orange-800/70 hover:text-orange-800"}`}
              data-testid={`desempenho-period-${p.key}`}>
              {p.label}
            </button>
          );
        })}
      </div>
      {value.periodo === "personalizado" && (
        <div className="flex items-end gap-2 justify-center" data-testid="desempenho-period-custom">
          <label className="text-[10px] font-bold uppercase text-orange-800 flex flex-col gap-0.5">
            Início
            <input type="date" value={value.inicio || ""} max={value.fim || undefined} onChange={(e) => set({ inicio: e.target.value })}
              className="h-9 rounded-md border border-orange-200 px-2 text-sm font-normal text-slate-800 bg-white" data-testid="desempenho-data-inicio" />
          </label>
          <CalendarRange className="w-4 h-4 text-orange-500 mb-2.5" />
          <label className="text-[10px] font-bold uppercase text-orange-800 flex flex-col gap-0.5">
            Fim
            <input type="date" value={value.fim || ""} min={value.inicio || undefined} onChange={(e) => set({ fim: e.target.value })}
              className="h-9 rounded-md border border-orange-200 px-2 text-sm font-normal text-slate-800 bg-white" data-testid="desempenho-data-fim" />
          </label>
        </div>
      )}
      {invalido && <div className="text-center text-xs text-rose-600" data-testid="desempenho-period-invalido">A data início deve ser anterior à data fim.</div>}
    </div>
  );
}
